import { useEffect } from "react";
import { Reveal, SectionLabel } from "@/components/Reveal";

const sections = [
  {
    title: "Information We Collect",
    text: "When you submit a property for review or send an inquiry through this website, we collect the information you provide — such as your name, email address, phone number, property details and any documents you choose to upload.",
  },
  {
    title: "How We Use It",
    text: "The information you provide is used solely to review your property or inquiry and to respond to you. We do not sell, rent or share your personal information with third parties for marketing purposes.",
  },
  {
    title: "Document Uploads",
    text: "Documents submitted through the property submission form (such as surveys, photos or planning documents) are stored securely and reviewed only in connection with your submission.",
  },
  {
    title: "Retention",
    text: "Submission records are retained only as long as needed to evaluate the opportunity and maintain appropriate business records.",
  },
  {
    title: "Contact",
    text: "Questions about this policy can be directed to info@stelcoredevelopment.com.",
  },
];

const PrivacyPolicy = () => {
  useEffect(() => {
    document.title = "Privacy Policy | Stelcore Development";
  }, []);

  return (
    <div data-testid="privacy-page">
      <section className="border-b border-ink/10">
        <div className="container-x py-16 md:py-24">
          <Reveal>
            <SectionLabel>Legal</SectionLabel>
            <h1 className="text-4xl sm:text-5xl tracking-tighter font-bold uppercase mt-6">Privacy Policy</h1>
          </Reveal>
        </div>
      </section>
      <section>
        <div className="container-x py-16 md:py-20 max-w-3xl">
          {sections.map((s) => (
            <Reveal key={s.title}>
              <div className="border-b border-ink/10 py-8">
                <h2 className="text-lg font-semibold uppercase tracking-tight mb-4">{s.title}</h2>
                <p className="text-sm text-graphite leading-relaxed">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
